export const languages = [
  { value: "en", name: "english" },
  { value: "es", name: "spanish" },
  { value: "fr", name: "french" },
  { value: "de", name: "german" },
];
